export enum OutputType {
  Pdf = 0,
  Csv = 1,
}
